module.exports = __webpack_public_path__ + "img/rarity2.e13ebc30.png";